const state = {
  report_referral: [],
  report_referral_id: [],
};

export default state;
